import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { db } from "@poseidon/firebase/firebase";
import { default as config } from "@poseidon/utils/config";
import {
  doc,
  addDoc,
  collection,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";
import { useCallback, useState } from "react";

export const useCreateAmlCheck = () => {
  const [loading, setLoading] = useState(false);
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();

  const run = useCallback(
    async (sailorId: string) => {
      try {
        setLoading(true);
        const kycAmlStatus =
          (await getDoc(
            doc(db, config.SaltCollection.SailorRiskProfile, sailorId)
          ).then((snap) => snap.get("kycAmlStatus"))) ?? "pending";

        await addDoc(
          collection(
            db,
            config.SaltCollection.SailorRiskProfile,
            sailorId,
            config.SaltCollection.AmlCheck
          ),
          {
            status: "pending",
            kycAmlStatus,
            requestedAt: serverTimestamp(),
          }
        );
        setToast("AML check created");
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message);
        } else {
          setError("Unknown error");
        }
      }
      setLoading(false);
    },
    [setError, setToast]
  );

  return { run, loading };
};
